import JSZip from 'jszip';
import { centerOfMass } from '@turf/center-of-mass';
import uniq from 'lodash.uniq';
import { poiClassAndSubclass } from './poi';

const unitCategoryToOsm = {
  brick: 'column',
  column: 'column',
  concrete: 'column',
  structure: 'column',
  unenclosedarea: 'area',
  walkway: 'corridor',
};

const occupantCategoryToOsm = {
  '3dprinting': null,
  'acai': null,
  'accessories': { shop: 'accessories' },
  'accounting': null,
  'acnetreatment': null,
  'acupuncture': null,
  'adoptionservices': null,
  'adulteducation': null,
  'adultentertainment': null,
  'adultstore': null,
  'advertising': null,
  'advisoryservices': null,
  'afghani': null,
  'african': null,
  'agritourism': null,
  'airfield': null,
  'airline': null,
  'airport.regional': null,
  'airportloungebar': null,
  'airportshuttle': null,
  'airsoft': null,
  'allergies': null,
  'alternativemedicine': null,
  'american.modern': null,
  'amusementpark': null,
  'amusementpark.ride': null,
  'animalshelter': null,
  'antiques': null,
  'apmstop': null,
  'appliances': null,
  'arabian': null,
  'arabian.pizza': null,
  'arcade': null,
  'archery': null,
  'architecture': null,
  'argentine': null,
  'armenian': null,
  'artgallery': null,
  'artinstruction': null,
  'arts.entertainment': null,
  'artsandcrafts': null,
  'artschool': null,
  'artstudio': null,
  'artstudio.rental': null,
  'artsupplies': null,
  'asianfusion': null,
  'astrologist': null,
  'asturian': null,
  'atm': null,
  'atm.cryptocurrency': null,
  'audiovideoequipment': null,
  'auditory': null,
  'australian': null,
  'australian.modern': null,
  'austrian': null,
  'austrian.schnitzel': null,
  'auto.accessibilityequipment': null,
  'auto.bodyshop': null,
  'auto.carbuyer': null,
  'auto.carshare': null,
  'auto.carwash': null,
  'auto.dealer.boat': null,
  'auto.dealer.car': null,
  'auto.dealer.motorcycle': null,
  'auto.dealer.rv': null,
  'auto.dentrepair.mobile': null,
  'auto.detailing': null,
  'auto.electric': null,
  'auto.evcharge': null,
  'auto.evcharge.dcfast': null,
  'auto.evcharge.tesla': null,
  'auto.glass': null,
  'auto.oilchange': null,
  'auto.parts': null,
  'auto.repair': null,
  'auto.repair.transmission': null,
  'auto.repair.wheelrim': null,
  'auto.repair.windshield': null,
  'auto.servicestation': null,
  'auto.shipping': null,
  'auto.stereoinstallation': null,
  'auto.tires': null,
  'auto.upholstery': null,
  'automotive': null,
  'autopartssupplies': null,
  'babyclothesandsupplies': null,
  'bagels': null,
  'bakedgoods': null,
  'ballonservices': null,
  'bangladeshi': null,
  'bank': null,
  'bar': null,
  'barbecue': null,
  'barber': null,
  'barfood': null,
  'barreclass': null,
  'baseballfield': null,
  'bathingarea': null,
  'batteries': null,
  'battingcages': null,
  'beach': null,
  'beautysalon': null,
  'beautyspas': null,
  'bedbreakfast': null,
  'beerbar': null,
  'beergarden': null,
  'beerhall': null,
  'beerwineandspirits': null,
  'beerwinespirits': null,
  'beisl': null,
  'belgian': null,
  'belgian.flemish': null,
  'bengali': null,
  'beveragestore': null,
  'bicycle.repair': null,
  'bicyclerental': null,
  'bicycleshop': null,
  'bikesandequipment': null,
  'billingservices': null,
  'bingo': null,
  'biryani': null,
  'bistro': null,
  'blacksea': null,
  'blinds': null,
  'blooddonation': null,
  'blooddonationcenter': null,
  'bodycontouring': null,
  'bodypiercing': null,
  'books': null,
  'booksmagazinesmusicvideo': null,
  'botanicalgarden': null,
  'bowlingalley': null,
  'boxing': null,
  'brazilian': null,
  'brazilian.centralbrazil': null,
  'brazilian.empanadas': null,
  'brazilian.northeasternbrazil': null,
  'brazilian.northernbrazil': null,
  'breakfastandbrunch': null,
  'brewery': null,
  'brewpub': null,
  'bridalstore': null,
  'british': null,
  'bubbletea': null,
  'buffet': null,
  'buildingsupplies': null,
  'bulgarian': null,
  'bulkmedicalbilling': null,
  'bungeejumping': null,
  'burgers': null,
  'burmese': null,
  'businesscampus': null,
  'businessconsulting': null,
  'busrental': null,
  'busstop': null,
  'butcher': null,
  'cabinets': null,
  'cafe': null,
  'cafeteria': null,
  'cajun': null,
  'cakes': null,
  'calligraphy': null,
  'cambodian': null,
  'canadian.modern': null,
  'candy': null,
  'candy.dagashi': null,
  'cannabisdispensary': null,
  'canteen': null,
  'cardioclasses': null,
  'cardiology': null,
  'cards.stationery': null,
  'careercounseling': null,
  'caribbean': null,
  'caricaturist': null,
  'carouselride': null,
  'carpet': null,
  'carrental': { amenity: 'car_rental' },
  'catering': null,
  'cellphoneaccessories': null,
  'challengecourse': null,
  'champagnebar': null,
  'cheese': null,
  'cheesesteaks': null,
  'chickenshop': null,
  'chickenwings': null,
  'childbirthschool': null,
  'childcare': null,
  'chilean': null,
  'chimneycakes': null,
  'chinese': null,
  'chinese.cantonese': null,
  'chinese.dimsum': null,
  'chinese.fuzhou': null,
  'chinese.hainan': null,
  'chinese.hakka': null,
  'chinese.henghwa': null,
  'chinese.hokkien': null,
  'chinese.hunan': null,
  'chinese.pekinese': null,
  'chinese.shanghainese': null,
  'chinese.szechuan': null,
  'chinese.teochew': null,
  'chinesebazaar': null,
  'chiropractic': null,
  'chocolate': null,
  'christmastrees': null,
  'churros': null,
  'cider': null,
  'cigarbar': null,
  'cinema': null,
  'cityhall': null,
  'climbing': null,
  'clinic': null,
  'clockrepair': null,
  'clothing': { shop: 'clothes' },
  'clothing.bespoke': { shop: 'clothes' },
  'clothing.childrens': { shop: 'clothes' },
  'clothing.mens': { shop: 'clothes' },
  'clothing.plussize': { shop: 'clothes' },
  'clothing.womens': { shop: 'clothes' },
  'cocktailbar': null,
  'coffee': { shop: 'coffee' },
  'coffee.tea': { shop: 'coffee' },
  'coffeeroaster': null,
  'coffeeteasupplies': null,
  'coincashingkiosk': null,
  'college': null,
  'colombian': null,
  'comedyclub': null,
  'comfortfood': null,
  'comicbooks': null,
  'commercialrealestate': null,
  'commissionedartists': null,
  'communitybookbox': null,
  'communitycenter': null,
  'computersandaccessories': null,
  'conceptshop': null,
  'concourse': null,
  'condominium': null,
  'congee': null,
  'constructionequipmentrental': null,
  'contractors': null,
  'conveniencestore': { shop: 'convenience' },
  'conveyorsushi': null,
  'cooking.instruction': null,
  'cookingschool': null,
  'copyshop': { shop: 'copyshop' },
  'corporateheadquarters': null,
  'corporateoffices': null,
  'corsican': null,
  'cosmetics': null,
  'cosmeticsurgery': null,
  'cosmetologyschool': null,
  'costumes': null,
  'countertopinstallation': null,
  'countryclub': null,
  'courier': null,
  'crepes': null,
  'cryotherapy': null,
  'cuban': null,
  'culturalcenter': null,
  'cupcakes': null,
  'currencyexchange': null,
  'customcakes': null,
  'custommerchandise': null,
  'cyclingclass': null,
  'cypriot': null,
  'czech': null,
  'danceclub': null,
  'danceschool': null,
  'dancestudio': null,
  'dancewear': null,
  'danish': null,
  'datarecovery': null,
  'dayspa': null,
  'dealer.usedvehicle': null,
  'delicatessen': null,
  'delicatessen.sandwiches': null,
  'dentalhygiene': null,
  'dentistry': null,
  'dentistry.cosmetic': null,
  'dentistry.general': null,
  'dentistry.pediatric': null,
  'departmentstore': null,
  'deptartmentstore': null,
  'dermatology': null,
  'desserts': null,
  'diagnosticimaging': null,
  'diagnosticservices': null,
  'dialysis': null,
  'dietician': null,
  'digitizingservices': null,
  'diner': null,
  'dinnertheater': null,
  'discountstore': null,
  'distillery': null,
  'divebar': null,
  'diyfood': null,
  'dmv': null,
  'dominican': null,
  'donair': null,
  'donationcenter': null,
  'donuts': null,
  'doorsalesandinstallation': null,
  'drivingrange': null,
  'drivingschool': null,
  'drycleaning': null,
  'drycleaninglaundry': null,
  'dumplings': null,
  'dumpsterrental': null,
  'dutyfree': null,
  'earnosethroat': null,
  'easterneuropean': null,
  'eatertainment': null,
  'editorialservices': null,
  'education': null,
  'educationservices': null,
  'egyptian': null,
  'electricians': null,
  'electronicappliances': null,
  'electronicparts': null,
  'electronicsrepair': null,
  'elementaryschool': null,
  'embroiderycrochet': null,
  'emergencymedicine': null,
  'emissionstesting': null,
  'empanadas': null,
  'employmentagency': null,
  'endodontics': null,
  'engraving': null,
  'escapegame': null,
  'ethiopian': null,
  'ethnicgrocerystore': null,
  'european.modern': null,
  'eventplanning': null,
  'eventspace': null,
  'experiences': null,
  'eyelashes': null,
  'eyewear.opticians': null,
  'fabricstore': null,
  'fairground': null,
  'falafel': null,
  'familyfriendly': null,
  'familyfuncenter': null,
  'familymedicine': null,
  'familyplanning': null,
  'familyrestaurant': null,
  'farm': null,
  'farmersmarket': null,
  'fashion': null,
  'fashionaccessories': null,
  'fastfood': { amenity: 'fastfood' },
  'fencing': null,
  'fengshui': null,
  'ferry': null,
  'fieldofplay': null,
  'filipino': null,
  'financialservices': null,
  'fingerprinting': null,
  'firearmstrainingschool': null,
  'fish': null,
  'fishandchips': null,
  'fitnessbootcamp': null,
  'fitnessequipment': null,
  'fitnessinstruction': null,
  'fixedbaseoperator': null,
  'flatbread': null,
  'flightinstructionschool': null,
  'floatspa': null,
  'flooringinstallationandrepair': null,
  'floraldesign': null,
  'florist': null,
  'florists': null,
  'flowers': null,
  'fondue': null,
  'foodcourt': null,
  'fooddelivery': null,
  'foodstand': null,
  'foodtruck': null,
  'formalwear': null,
  'formalwear.rental': null,
  'freiduria': null,
  'french': null,
  'french.alsatian': null,
  'french.auvergnat': null,
  'french.baguette': null,
  'french.berrichon': null,
  'french.bourguignon': null,
  'french.brasserie': null,
  'french.lyonnais': null,
  'french.nicois': null,
  'french.provencal': null,
  'friterie': null,
  'frozenfoods': null,
  'fruitandvegetables': null,
  'fuelstation': null,
  'funeralservices': null,
  'furclothing': null,
  'furniture': { shop: 'furniture' },
  'furniture.rental': null,
  'furniturestore': { shop: 'furniture' },
  'gardening': null,
  'gastroenterology': null,
  'gastropubs': null,
  'gelato': null,
  'georgian': null,
  'german': null,
  'german.baden': null,
  'german.bavarian': null,
  'german.currysausage': null,
  'german.easterngerman': null,
  'german.fischbroetchen': null,
  'german.franconian': null,
  'german.hessian': null,
  'german.heuriger': null,
  'german.northerngerman': null,
  'german.palatine': null,
  'german.rhinelandian': null,
  'german.swabian': null,
  'giblets': null,
  'giftshops': null,
  'glutenfree': null,
  'gokarting': null,
  'goldmerchants': null,
  'golf': null,
  'golf.instruction': null,
  'golfequipment': null,
  'golfshop': null,
  'gourmetfood': null,
  'gourmetmarket': null,
  'graphicaldesign': null,
  'greek': null,
  'grillingequipment': null,
  'grocery': null,
  'grocery.asian': null,
  'grocery.chinese': null,
  'grocery.indian': null,
  'grocery.japanese': null,
  'grocery.korean': null,
  'grocery.persian': null,
  'grocerystore': null,
  'guitarstore': null,
  'gunrange': null,
  'gunsandammo': null,
  'gym': null,
  'gymnastics': null,
  'hairblowout': null,
  'haircutsstyling': null,
  'haircutsstyling.mens': null,
  'hairextensions': null,
  'hairloss': null,
  'hairremoval': null,
  'hairremoval.laser': null,
  'hairremoval.threading': null,
  'hairremoval.waxing': null,
  'hairstylist': null,
  'haitian': null,
  'halal': null,
  'hardware': null,
  'hats': null,
  'hauntedhouse': null,
  'hawaiian': null,
  'headshop': null,
  'healthcare': null,
  'healthcarecenter': null,
  'healthyfoods': null,
  'hearingaidproviders': null,
  'hearingaids': null,
  'hennaartist': null,
  'herbalmedicine': null,
  'herbsandspices': null,
  'highschool': null,
  'himalayan': null,
  'hobbyshop': null,
  'holidaydecorations': null,
  'homeandgarden': null,
  'homeappliancerepair': null,
  'homeautomation': null,
  'homecleaning': null,
  'homedecor': null,
  'homedevelopers': null,
  'homegarden': null,
  'homehealthcare': null,
  'homeopathy': null,
  'hometheaterinstallation': null,
  'honey': null,
  'hongkong.cafe': null,
  'hookahbar': null,
  'horsequipment': null,
  'hospital': null,
  'hostel': null,
  'hotdogs': null,
  'hotel': null,
  'hotel.business': null,
  'hotel.capsule': null,
  'hotelbar': null,
  'hotpot': null,
  'hottubandpool': null,
  'housingcooperative': null,
  'hungarian': null,
  'huntingfishingsupplies': null,
  'hvac': null,
  'hypermarket': null,
  'iberian': null,
  'icecream': null,
  'importedfood': null,
  'indian': null,
  'indian.andhra': null,
  'indian.assamese': null,
  'indian.awadhi': null,
  'indian.bihari': null,
  'indian.chettinad': null,
  'indian.goan': null,
  'indian.gujarat': null,
  'indian.hyderabadi': null,
  'indian.kerala': null,
  'indian.konkan': null,
  'indian.lucknowi': null,
  'indian.maharashtrian': null,
  'indian.malwani': null,
  'indian.mangalorean': null,
  'indian.northindian': null,
  'indian.oriya': null,
  'indian.rajasthani': null,
  'indian.southindian': null,
  'indonesian': null,
  'informationtechnology': null,
  'installmentloanservices': null,
  'insulationinstallation': null,
  'insurance': null,
  'insurance.auto': null,
  'insurance.health': null,
  'insurance.home': null,
  'insurance.life': null,
  'interiordesign': null,
  'internalmedicine': null,
  'internationalfood': null,
  'internetbooth': null,
  'internetcafe': null,
  'internetserviceprovider': null,
  'investmentbanking': null,
  'irish': null,
  'irishpub': null,
  'israeli': null,
  'italian': null,
  'italian.abruzzese': null,
  'italian.altoatesine': null,
  'italian.apulian': null,
  'italian.calabrian': null,
  'italian.cucinacampana': null,
  'italian.diner': null,
  'italian.emilian': null,
  'italian.friulan': null,
  'italian.lumbard': null,
  'italian.napoletana': null,
  'italian.norcinerie': null,
  'italian.piedmont': null,
  'italian.roman': null,
  'italian.sardinian': null,
  'italian.sicilian': null,
  'italian.tuscan': null,
  'italian.venetian': null,
  'ivhydration': null,
  'izakaya': null,
  'japanese': null,
  'japanese.bento': null,
  'japanese.blowfish': null,
  'japanese.curry': null,
  'japanese.donburi': null,
  'japanese.gyudon': null,
  'japanese.handrolls': null,
  'japanese.horumon': null,
  'japanese.kushikatsu': null,
  'japanese.nikkei': null,
  'japanese.oden': null,
  'japanese.okonomiyaki': null,
  'japanese.onigiri': null,
  'japanese.oyakodon': null,
  'japanese.ramen': null,
  'japanese.shabushabu': null,
  'japanese.soba': null,
  'japanese.sukiyaki': null,
  'japanese.takoyaki': null,
  'japanese.tempura': null,
  'japanese.teppanyaki': null,
  'japanese.tonkatsu': null,
  'japanese.udon': null,
  'japanese.unagi': null,
  'japanese.westernjapanese': null,
  'japanese.yakiniku': null,
  'japanese.yakitori': null,
  'japanesesweets': null,
  'jewelry': null,
  'jewelryrepair': null,
  'jewish': null,
  'juicebar': null,
  'kaiseki': null,
  'karaoke': null,
  'kashmiri': null,
  'kebab': null,
  'kidsactivities': null,
  'kimonos': null,
  'kindergarten': null,
  'kiosk': null,
  'kiosk.food': null,
  'kitchenandbath': null,
  'kitchenincubator': null,
  'knifesharpening': null,
  'knittingsupplies': null,
  'kopitiam': null,
  'korean': null,
  'kosher': null,
  'kurdish': null,
  'laboratorytesting': null,
  'landmark': null,
  'landscaping': null,
  'languageschool': null,
  'laotian': null,
  'lasereyesurgery': null,
  'lasertag': null,
  'latinamerican': null,
  'laundromat': null,
  'laundryservices': null,
  'lawyer': null,
  'lawyer.business': null,
  'lawyer.criminaldefense': null,
  'lawyer.divorce': null,
  'lawyer.estateplanning': null,
  'lawyer.immigration': null,
  'lawyer.litigation': null,
  'lawyer.personalinjury': null,
  'lawyer.realestate': null,
  'lawyer.tax': null,
  'lawyer.willtrustprobate': null,
  'lawyer.workerscomp': null,
  'leathergoods': null,
  'lebanese': null,
  'legalservices': null,
  'library': null,
  'lifecoach': null,
  'lighting': null,
  'ligurian': null,
  'limo': null,
  'linens': null,
  'lingerie': null,
  'livestocksales': null,
  'localservices': null,
  'locksmith': null,
  'lotterystand': null,
  'loungebar': null,
  'luggage': null,
  'luggagestorage': null,
  'macaron': null,
  'magicians': null,
  'mailboxcenter': null,
  'makeupartist': null,
  'malaysian': null,
  'mamak': null,
  'manicurists': null,
  'marketing': null,
  'martialarts': null,
  'massageschool': null,
  'massagetherapist': null,
  'massagetherapy': null,
  'maternitywear': null,
  'mattresses': null,
  'mauritian': null,
  'meatballs': null,
  'medicalcenter': null,
  'medicalspa': null,
  'medicalsupplies': null,
  'mediterranean': null,
  'mexican': null,
  'mexican.easternmexican': null,
  'mexican.jaliscan': null,
  'mexican.modern': null,
  'mexican.northernmexican': null,
  'mexican.oaxacan': null,
  'mexican.pueblan': null,
  'mexican.yucatan': null,
  'middleeastern': null,
  'militarybase': null,
  'milkbar': null,
  'milkshakes': null,
  'minigolf': null,
  'mobilephonerepair': null,
  'mobilephones': null,
  'moneytransferservices': null,
  'mongolian': null,
  'moroccan': null,
  'mortgagebroker': null,
  'motorcyclingclothing': null,
  'movierental.kiosk': null,
  'mughlai': null,
  'museum.art': null,
  'museum.children': null,
  'museum.history': null,
  'musicalinstruments': null,
  'musicalinstrumentservices': null,
  'musicvenue': null,
  'musicvideo': null,
  'naga': null,
  'nasilemak': null,
  'naturopathy': null,
  'nepalese': null,
  'newspapersandmagazines': null,
  'newzealand': null,
  'nicaraguan': null,
  'nightfood': null,
  'nonprofit': null,
  'noodles': null,
  'northamerican.traditional': null,
  'norwegian': null,
  'notarypublic': null,
  'nurseries.gardening': null,
  'nyonya': null,
  'obgyn': null,
  'observatory': null,
  'occupationaltherapy': null,
  'officebuilding': null,
  'officeequipmentandsupplies': null,
  'okinawan': null,
  'oliveoil': null,
  'opensandwiches': null,
  'opera.ballet': null,
  'opthamalogy': null,
  'opticians': null,
  'optometry': null,
  'oralsurgery': null,
  'organicfood': null,
  'oriental': null,
  'orthodontics': null,
  'orthopedics': null,
  'orthotics': null,
  'osteopathy': null,
  'ottoman': null,
  'outdoorfurniture': null,
  'outdoorgear': null,
  'outletmall': null,
  'outletstore': null,
  'oxygenbar': null,
  'pachinko': null,
  'packagelocker': null,
  'packing': null,
  'packingsupplies': null,
  'paella': null,
  'painmanagement': null,
  'paintandsip': null,
  'painting': null,
  'paintstores': null,
  'paintyourownpottery': null,
  'pakistani': null,
  'parentingschool': null,
  'parking': null,
  'parks': null,
  'parma': null,
  'parsi': null,
  'partycharacters': null,
  'partyequipment.rental': null,
  'partysupplies': null,
  'passportvisaservices': null,
  'pasta': null,
  'pathology': null,
  'pawn': null,
  'paydayloan': null,
  'pediatrics': null,
  'performingarts': null,
  'perfume': null,
  'periodontics': null,
  'permanentmakeup': null,
  'persian': null,
  'personalcare': null,
  'personalshopper': null,
  'personaltrainer': null,
  'peruvian': null,
  'pets': null,
  'pets.adoption': null,
  'pets.boarding': null,
  'pets.grooming': null,
  'pets.photography': null,
  'pets.sitting': null,
  'pets.training': null,
  'pets.transportation': null,
  'petstore': null,
  'petstore.fish': null,
  'petstore.reptile': null,
  'pharmacy': null,
  'pharmacystore': null,
  'phonechargingstation': null,
  'photobooth.rental': null,
  'photography': null,
  'photography.event': null,
  'photography.session': null,
  'photographyequipment': null,
  'photographystore': null,
  'physicaltherapy': null,
  'physician': null,
  'piadina': null,
  'pianobar': null,
  'pianostore': null,
  'pictureframing': null,
  'pilates': null,
  'pita': null,
  'pizza': { amenity: 'restaurant' },
  'placeofworship': null,
  'placeofworship.church': null,
  'placeofworship.mosque': null,
  'placeofworship.synagogue': null,
  'placeofworship.unitarian': null,
  'planetarium': null,
  'plasticsurgery': null,
  'playcenter': null,
  'playground': null,
  'playsets': null,
  'plaza': null,
  'podiatrists': null,
  'podiatry': null,
  'poke': null,
  'poledancingschool': null,
  'policestation': null,
  'policestation.koban': null,
  'polish': null,
  'polish.pierogis': null,
  'poolcleaning': null,
  'poolhall': null,
  'pooltablesupplies': null,
  'popcorn': null,
  'popup': null,
  'popupshops': null,
  'portuguese': null,
  'portuguese.alentejo': null,
  'portuguese.algarve': null,
  'portuguese.azores': null,
  'portuguese.beira': null,
  'portuguese.fadohouse': null,
  'portuguese.madeira': null,
  'portuguese.minho': null,
  'portuguese.ribatejo': null,
  'portuguese.trasosmontes': null,
  'postoffice': null,
  'postoffice.authorizedagent': null,
  'potatoes': null,
  'poutineries': null,
  'prenatal': null,
  'preschool': null,
  'pretzels': null,
  'preventivemedicine': null,
  'printmedia': null,
  'privateinvestigation': null,
  'privatejetcharter': null,
  'privateschool': null,
  'privateshuttlebus': null,
  'professionalservices': null,
  'professionalsportsteam': null,
  'propertymanagement': null,
  'psychiatrists': null,
  'psychiatry': null,
  'psychic': null,
  'psychology': null,
  'pub': {
    amenity: 'pub'
  },
  'publicart': null,
  'publiclibrary': null,
  'publicservices.government': null,
  'publictransport': null,
  'puertorican': null,
  'pulmonology': null,
  'punjabi': null,
  'racetrack': null,
  'radiology': null,
  'radiostation': null,
  'rawfood': null,
  'realestate.agents': null,
  'realestate.services': null,
  'realestateagents': null,
  'realestateagents.commercial': null,
  'realestateservices': null,
  'recordingstudio': null,
  'recreation': null,
  'recreationcenter': null,
  'recyclingcenter': null,
  'reflexology': null,
  'religiousitems': null,
  'rental.videoandgame': null,
  'researchanddevelopment': null,
  'residentialapartments': null,
  'restaurant': { amenity: 'restaurant' },
  'retirementhome': null,
  'reunionnese': null,
  'reupholstery': null,
  'riceshop': null,
  'rideshare': null,
  'robatayaki': null,
  'rockclimbing': null,
  'rodizio': null,
  'romanian': null,
  'roofing': null,
  'rotisseriechicken': null,
  'rugs': null,
  'russian': null,
  'sakebar': null,
  'salad': null,
  'salvadoran': null,
  'sandwiches': null,
  'sauna': null,
  'scandinavian': null,
  'scandinaviandesign': null,
  'school': null,
  'scottish': null,
  'screenprinting': null,
  'screenprinting.tshirt': null,
  'seafood': null,
  'seafoodmarket': null,
  'securitysystems': null,
  'selfstorage': null,
  'senegalese': null,
  'seniorcenter': null,
  'serbianandcroatian': null,
  'sewingalterations': null,
  'sharedofficespace': null,
  'shavedice': null,
  'shavedsnow': null,
  'shippingcenters': null,
  'shippingdropbox': null,
  'shoerepair': null,
  'shoes': { shop: 'shoes'},
  'shoeshine': null,
  'shoestore': { shop: 'shoes' },
  'shopping': { shop: 'supermarket' },
  'shoppingpassage': null,
  'shutterinstallation': null,
  'signature': null,
  'signmaking': null,
  'silentdisco': null,
  'singaporean': null,
  'skatepark': null,
  'skatingequipment': null,
  'skatingrink': null,
  'skiequipment': null,
  'skincare': null,
  'skydiving': null,
  'sleepwear': null,
  'slovakian': null,
  'soccer': null,
  'socialclub': null,
  'socialservices': null,
  'softwaredevelopment': null,
  'solarinstallation': null,
  'sommeliers': null,
  'soulfood': null,
  'soup': null,
  'southafrican': null,
  'southernunitedstates': null,
  'southwestunitedstates': null,
  'souvenirs': null,
  'spanish': null,
  'spanish.andalusian': null,
  'spanish.basque': null,
  'spanish.catalan': null,
  'spanish.galician': null,
  'specialtyfood': null,
  'specialtyschool': null,
  'spinclass': null,
  'spiritualproducts': null,
  'sportinggoods': null,
  'sportsbar': null,
  'sportsclub': null,
  'sportsequipment.rental': null,
  'sportsgoods': null,
  'sportsmedicine': null,
  'sportsschool': null,
  'sportswear': null,
  'srilankan': null,
  'stationery': null,
  'steak': null,
  'stockings': null,
  'streetvendor': null,
  'structuralengineers': null,
  'subwaystation': null,
  'supermarket': { shop: 'supermarket' },
  'supperclub': null,
  'surfacerefinishing': null,
  'surfing': null,
  'surfingequipment': null,
  'surgeon': null,
  'sushi': { amenity: 'restaurant' },
  'swedish': null,
  'swedish.traditional': null,
  'swimminginstruction': null,
  'swimmingpool': null,
  'swimwear': null,
  'swiss': null,
  'syrian': null,
  'taberna': null,
  'tabletopgames': null,
  'tableware': null,
  'tacos': { amenity: 'fast_food' },
  'taiwanese': null,
  'taiyaki': null,
  'talentagencies': null,
  'tamales': null,
  'tanningbeds': null,
  'tanningservices': null,
  'tapas': null,
  'tapas.smallplate': null,
  'tattoo': { shop: 'tattoo' },
  'tattoo.removal': null,
  'taxi': { amenity: 'taxi' },
  'taxistand': null,
  'taxoffice': null,
  'taxservices': null,
  'tea': { shop: 'tea' },
  'teachersupplies': null,
  'teambuilding': null,
  'teethwhitening': null,
  'telecommunications': null,
  'televisionserviceproviders': null,
  'televisionstation': null,
  'tennis.instruction': null,
  'terminal': null,
  'terminal.bus': null,
  'testpreparationschool': null,
  'texmex': null,
  'thai': null,
  'theater.drivein': null,
  'theater.movie': null,
  'themedcafe': null,
  'thriftstore': null,
  'tibetan': null,
  'tickets': null,
  'tikibar': null,
  'titleloan': null,
  'tobaccoshop': { shop: 'tobacco' },
  'tofu': null,
  'touristattraction': null,
  'tours': null,
  'tours.boat': null,
  'tours.bus': null,
  'tours.scooter': null,
  'tours.walking': null,
  'towncarservice': null,
  'toys': null,
  'toystore': null,
  'traditionalchinesemedicine': null,
  'trainserviceprovider': null,
  'trainstation': null,
  'trampolining': null,
  'transitlounge': null,
  'translationservices': null,
  'transportationservices': null,
  'trattoria': null,
  'travelagent': null,
  'travelservices': null,
  'trinidadian': null,
  'trophyshops': null,
  'truckrental': null,
  'tuina': null,
  'turkish': null,
  'turkish.cheekufta': null,
  'turkish.gozleme': null,
  'turkish.homemadefood': null,
  'turkish.lahmacun': null,
  'turkish.ravioli': null,
  'tutoring': null,
  'ukrainian': null,
  'uniforms': null,
  'urgentcare': null,
  'usedbooks': null,
  'utilities': null,
  'uzbek': null,
  'vacationhome': null,
  'vacationhome.agent': null,
  'valetservices': null,
  'vapeshops': null,
  'vascularmedicine': null,
  'vegan': null,
  'vegetarian': null,
  'vendingmachine': null,
  'vendingmachine.beverage': null,
  'venezuelan': null,
  'venison': null,
  'veteransorganization': null,
  'veterinarian': null,
  'videofilmproduction': null,
  'videogamesandconsoles': null,
  'vietnamese': null,
  'vintageclothing': null,
  'vinylrecords': null,
  'virtualreality': null,
  'visitorcenter': null,
  'vitaminssupplements': null,
  'vocalcoach': null,
  'vocationalschool': null,
  'waffles': null,
  'walkinclinic': null,
  'warehouse': null,
  'watches': null,
  'watchrepair': null,
  'waterpark': null,
  'waterpurification': null,
  'webdesign': null,
  'weddingchappel': null,
  'weddingplanning': null,
  'weightloss': null,
  'welsh': null,
  'whiskeybar': null,
  'wholesalemerchant': null,
  'wholesaler': null,
  'wigs': null,
  'windowinstallation': null,
  'winebar': null,
  'winery': null,
  'winetasting': null,
  'wok': null,
  'wraps': null,
  'yoga': null,
  'youthclub': null,
  'yugoslav': null,
};

const amenitiesCategoryToOsm = {
  'amphitheater': null,
  'animalreliefarea': null,
  'arrivalgate': null,
  'atm': { amenity: 'atm' },
  'babychanging': null,
  'baggagecarousel': null,
  'baggagecarousel.intl': null,
  'baggagecarts': null,
  'baggageclaim': null,
  'baggageclaim.oversize': null,
  'baggagerecheck': null,
  'baggagestorage': null,
  'boardinggate': null,
  'boardinggate.aircraft': null,
  'boardinggate.bus': null,
  'boardinggate.ferry': null,
  'boardinggate.train': null,
  'bus': null,
  'bus.muni': null,
  'bus.national': null,
  'businesscenter': null,
  'cabin': null,
  'caregiver': null,
  'carrental': null,
  'cashier': null,
  'changemachine': null,
  'checkin': null,
  'checkin.desk': null,
  'checkin.desk.oversizebaggage': null,
  'checkin.desk.transfer': null,
  'checkin.selfservice': null,
  'childplayarea': null,
  'coinlocker': null,
  'copymachine': null,
  'defibrillator': { emergency: 'defibrillator' },
  'drinkingfountain': null,
  'eatingdrinking': null,
  'elevator': null,
  'emergencyshelter': null,
  'entry': null,
  'escalator': null,
  'exhibit': null,
  'faregate': null,
  'faregate.oversized': null,
  'fieldofplay': null,
  'fieldofplay.americanfootball': null,
  'fieldofplay.baseball': null,
  'fieldofplay.basketball': null,
  'fieldofplay.fieldhockey': null,
  'fieldofplay.icehockey': null,
  'fieldofplay.rugby': null,
  'fieldofplay.soccer': null,
  'fieldofplay.softball': null,
  'fieldofplay.tennis': null,
  'fieldofplay.trackfield': null,
  'fieldofplay.volleyball': null,
  'firealarmpullstation': null,
  'fireextinguisher': null,
  'firstaid': null,
  'fittingroom': null,
  'foodservice': null,
  'gatearea': null,
  'groundtransportation': null,
  'guestservices': null,
  'handsanitizerstation': null,
  'healthscreening': null,
  'hoteling': null,
  'immigration': null,
  'information': { tourism: 'information' },
  'information.bid': { tourism: 'information' },
  'information.carrental': { tourism: 'information' },
  'information.hotel': { tourism: 'information' },
  'information.mufid': { tourism: 'information' },
  'information.mufid.arrivals': { tourism: 'information' },
  'information.mufid.departures': { tourism: 'information' },
  'information.transit': { tourism: 'information' },
  'landmark': null,
  'library': null,
  'limo': null,
  'lostandfound': null,
  'mailbox': null,
  'meditation': null,
  'meetingpoint': null,
  'mobilityrescue': null,
  'mothersroom': null,
  'movingwalkway': null,
  'paidarea': null,
  'parkandride': null,
  'parking': null,
  'parking.bicycle': null,
  'parking.compact': null,
  'parking.ev': null,
  'parking.longterm': null,
  'parking.motorcycle': null,
  'parking.shortterm': null,
  'parking.waitingarea': null,
  'payphone': null,
  'pedestriancrossing': null,
  'peoplemover': null,
  'phone': { amenity: 'telephone' },
  'phone.emergency': null,
  'photobooth': null,
  'platform': null,
  'police': null,
  'powerchargingstation': null,
  'prayerroom': null,
  'prayerroom.buddhism': null,
  'prayerroom.christianity': null,
  'prayerroom.hinduism': null,
  'prayerroom.islam': null,
  'prayerroom.islam.female': null,
  'prayerroom.islam.male': null,
  'prayerroom.judaism': null,
  'prayerroom.shintoism': null,
  'prayerroom.sikh': null,
  'prayerroom.taoic': null,
  'privatelounge': null,
  'productreturn': null,
  'rail.muni': null,
  'rail.national': null,
  'ramp': null,
  'reception.desk': null,
  'recreation': null,
  'restroom': { amenity: 'toilets' },
  'restroom.family': { amenity: 'toilets' },
  'restroom.female': { amenity: 'toilets' },
  'restroom.female.wheelchair': { amenity: 'toilets', wheelchair: 'yes' },
  'restroom.male': { amenity: 'toilets' },
  'restroom.male.wheelchair': { amenity: 'toilets', wheelchair: 'yes' },
  'restroom.transgender': { amenity: 'toilets' },
  'restroom.transgender.wheelchair': { amenity: 'toilets', wheelchair: 'yes' },
  'restroom.unisex': { amenity: 'toilets' },
  'restroom.unisex.wheelchair': { amenity: 'toilets', wheelchair: 'yes' },
  'restroom.wheelchair': { amenity: 'toilets', wheelchair: 'yes' },
  'rideshare': null,
  'seat': null,
  'seating': null,
  'security': null,
  'security.checkpoint': null,
  'security.inspection': null,
  'service': null,
  'shower': null,
  'shuttle': null,
  'sleepbox': null,
  'smokingarea': null,
  'stairs': null,
  'storage': null,
  'strollerrental': null,
  'studentadmissions': null,
  'studentservices': null,
  'swimmingpool': null,
  'swimmingpool.children': null,
  'swimmingpool.family': null,
  'taxi': null,
  'ticketing': null,
  'ticketing.airline': null,
  'ticketing.bus': null,
  'ticketing.bus.muni': null,
  'ticketing.bus.national': null,
  'ticketing.rail': null,
  'ticketing.rail.muni': null,
  'ticketing.rail.national': null,
  'ticketing.shuttle': null,
  'traintrack': null,
  'transit': null,
  'unspecified': null,
  'valet': null,
  'vendingmachine': { amenity: 'vending_machine' },
  'vendingmachine.trainticket': { amenity: 'vending_machine', vending: 'public_transport_tickets' },
  'wheelchairassist': null,
  'wifi': null,
  'yoga': null,
};


export function unitCategoryToClass(category) {
  return unitCategoryToOsm[category] ? unitCategoryToOsm[category] : 'room';
}

export function unitFeatureToAccess(feature) {
  if (['employeesonly', 'restricted'].includes(feature.properties.restriction)
     || feature.properties.category === 'nonpublic') {
    return 'no';
  }
  return 'yes';
};

export function collectUnitIdsWithPoi(anchors, occupants, amenities) {
  const unitIdOccupants = occupants.filter((feature) => {
    return occupantCategoryToOsm[feature.properties.category];
  }).map((feature, index) => {
    return anchors.find((anchor) => anchor.id === feature.properties.anchor_id).properties.unit_id;
  });
  const unitIdAmenities = amenities.filter((feature) => {
    return amenitiesCategoryToOsm[feature.properties.category];
  }).flatMap((feature, index) => {
    return feature.properties.unit_ids;
  });
  return uniq(unitIdOccupants.concat(unitIdAmenities));
}

export function transformOccupantFeatures(units, anchors, occupants, levelsById) {
  return occupants.filter((feature) => {
    return occupantCategoryToOsm[feature.properties.category];
  }).map((feature, index) => {
    const anchor = anchors.find((anchor) => anchor.id === feature.properties.anchor_id);
    const unit = units.find((unit) => unit.id === anchor.properties.unit_id);
    const mapping = occupantCategoryToOsm[feature.properties.category];
    const newFeature = {
      geometry: anchor.geometry,
      properties: {
        id: `poi_${index}`,
        ...mapping,
        'name': feature.properties.name.en,
        'name:latin': feature.properties.name.en,
        level: levelsById[unit.properties.level_id],
        opening_hours: feature.properties.hours,
        website: feature.properties.website,
        phone: feature.properties.phone,
      }
    };
    const [classe, subclass] = poiClassAndSubclass(newFeature);
    return {
      ...newFeature,
      properties: {
        ...newFeature.properties,
        class: classe,
        subclass
      }
    };
  });
}

export function transformOpeningFeatures(openings, levelsById) {
  return openings.map((feature, index) => {
    const featureCenter = centerOfMass(feature);
    return {
      ...feature,
      ...featureCenter,
      properties: {
        id: `poi_door_${index}`,
        door: 'yes',
        class: 'entrance',
        subclass: 'door',
        level: levelsById[feature.properties.level_id]
      }
    };
  });
}

export function transformAmenityFeatures(units, amenities, levelsById) {
  return amenities.filter((feature) => {
    return amenitiesCategoryToOsm[feature.properties.category];
  }).map((feature, index) => {
    const unit = units.find((unit) => feature.properties.unit_ids.includes(unit.id));
    const mapping = amenitiesCategoryToOsm[feature.properties.category];
    const newFeature = {
      ...feature,
      properties: {
        id: `poi_amenity_${index}`,
        ...mapping,
        'name': feature.properties.name?.en,
        'name:latin': feature.properties?.name?.en,
        level: levelsById[unit.properties.level_id],
        opening_hours: feature.properties.hours,
        website: feature.properties.website,
        phone: feature.properties.phone,
      }
    };
    const [classe, subclass] = poiClassAndSubclass(newFeature);
    return {
      ...newFeature,
      properties: {
        ...newFeature.properties,
        class: classe,
        subclass
      }
    };
  });
}

export function transformAreaFeatures(units, unitIdsWithPoi, levelsById) {
  return units.map((feature) => {
    return {
      ...feature,
      properties: {
        ...feature.properties,
        class: unitCategoryToClass(feature.properties.category),
        is_poi: unitIdsWithPoi.includes(feature.id),
        access: unitFeatureToAccess(feature),
        level: levelsById[feature.properties.level_id]
      }
    };
  });
}

async function readFileJSONFromZip(zip, filename) {
  return JSON.parse(await zip.file(filename).async('string'));
}

export async function transformIMDFFile(file) {
  const zip = await JSZip.loadAsync(file);
  const levels = await readFileJSONFromZip(zip, 'level.geojson');
  const units = await readFileJSONFromZip(zip, 'unit.geojson');
  const occupants = await readFileJSONFromZip(zip, 'occupant.geojson');
  const anchors = await readFileJSONFromZip(zip, 'anchor.geojson');
  const openings = await readFileJSONFromZip(zip, 'opening.geojson');
  const amenities = await readFileJSONFromZip(zip, 'amenity.geojson');
  const levelsById = levels.features.reduce((memo, level) => {
    memo[level.id] = level.properties.short_name.en;
    return memo;
  }, {});
  const unitIdsWithPoi = collectUnitIdsWithPoi(anchors.features, occupants.features, amenities.features);
  return {
    area: {
      type: 'FeatureCollection',
      features: transformAreaFeatures(units.features, unitIdsWithPoi, levelsById)
    },
    poi: {
      type: 'FeatureCollection',
      features: [
        ...transformOccupantFeatures(units.features, anchors.features, occupants.features, levelsById),
        ...transformAmenityFeatures(units.features, amenities.features, levelsById),
        ...transformOpeningFeatures(openings.features, levelsById),
      ]
    }
  };
}
